export default "__VITE_ASSET__e660608a__"